// Investiture
import React from 'react';
import Kannadaccaclass1 from '../views/Kannadaccaclass1';

const InvestiturePage = () => {
  return < Kannadaccaclass1/>;
};

export default InvestiturePage;